module.exports = window.sharedLibraries["nushop"]["react-router-dom"];